(function () {
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var input = e.target.closest('[data-qty]').querySelector('input');
    var min = parseInt(input.min || '0', 10);
    var val = parseInt(input.value || '0', 10) + (plus ? 1 : -1);
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  var variant = document.getElementById('variant-select');
  var price = document.querySelector('[data-price] .price__now');
  if (variant && price) {
    variant.addEventListener('change', function () {
      var opt = variant.options[variant.selectedIndex];
      if (opt.dataset.price) price.textContent = opt.dataset.price;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.value);
      history.replaceState(null, '', url.toString());
    });
  }

  document.querySelectorAll('select[data-default]').forEach(function (s) {
    if (s.dataset.default) s.value = s.dataset.default;
  });

  document.querySelectorAll('form[data-confirm]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      if (!window.confirm(f.dataset.confirm)) e.preventDefault();
    });
  });
})();
